import { render, staticRenderFns } from "./CollectionDetail.vue?vue&type=template&id=5d07a5cd"
import script from "./CollectionDetail.vue?vue&type=script&lang=js"
export * from "./CollectionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports